import StaffManagementConst from "../staff-management-const";
import { STAFF_WORKER_STATUS } from "./staff-workers-api-helper";


const validStatuses = Object.values(STAFF_WORKER_STATUS);

export const getStaffWorkersStatusFromSearch = (search = "") => {
    const value = new URLSearchParams(search).get("status");
    return validStatuses.includes(value) ? value : undefined;
};

export const updateStaffWorkersStatusSearch = (search = "", status) => {
    const params = new URLSearchParams(search);
    if (validStatuses.includes(status)) params.set("status", status);
    else params.delete("status");
    const query = params.toString();
    return query ? `?${ query }` : "";
};

export const getStaffWorkersStatusUrl = (eventID, status) => (
    `${ StaffManagementConst.basePath }/${ encodeURIComponent(String(eventID).trim()) }/workers${ updateStaffWorkersStatusSearch("", status) }`
);
